import React, {Component} from "react"
import PropTypes from "prop-types"

import {Card} from "semantic-ui-react"
import shop from "shop/shop"

let instanceIndex = 0

class ProductSearchExtra extends Component {

  constructor(props) {
    super( props )
    this.state = {
      products: [],
    }
    instanceIndex++
  }

  componentWillReceiveProps(props) {
    if ( props !== this.props ) {
      this.load( props )
    }
    console.log("ProductSearchExtra",props)
  }

  componentDidMount() {
    this.load( this.props )
    console.log("ProductSearchExtra",this.props)
  }

  load({ cats, query }) {
    // API bottleneck
    console.log("ProductSearchExtra",cats,query)
    window.setTimeout( () => {
        if ( cats.length > 0 ) this.loadFromCategories( cats, query )
        if ( cats.length === 0 ) this.loadSearch( query )
      },
      5 * instanceIndex
    )
  }

  loadSearch(query) {
    console.log("ProductSearchExtra",query);
    const { extra, extraValue } = this.props
    let filterObject                  = new shop.Filter()
    let filter = filterObject
      .searchField( true )
      .field( extra )
      .query( extraValue )

    let q                       = {
      filter,
      count: this.props.count,
      page: 1
    }

    shop.products.search( "%%", q )
      .then( res => {
        this.setState( {
          size:     res.size,
          products: res.products,
          query,
        } )
      } )
      .then( this.handleProducts )
  }

  loadFromCategories(cats, query) {
    this.lastQuery = { cats, query }
    shop.products.fromCategory( cats, {
      count: this.props.count || 4, page: 1, query
    } )
      .then( this.handleProducts )
  }

  handleProducts = (response = {}) => {
    let { products } = response
    console.log("ProductSearchExtra",products)
    if ( !products ) return
    this.setState( { products } )
    if ( this.props.onload ) {
      this.props.onload( response )
    }
  }

  render() {
    let Child     = this.props.repeat
    let { title } = this.props
    let products  = this.state.products.map( product => <Child key={product.map_id}
                                                               product={product}/> )

    if ( products.length === 0 ) {
      return null
    }

    return (
      <div key={this.props.key}>
        {(title) ? <div className="row-title"><h2>{title}</h2></div> : null}
        <Card.Group itemsPerRow="4">
          {products}
        </Card.Group>
      </div>
    )
  }
}

ProductSearchExtra.defaultProps = {
  count: 4, start: 0, query: "%%", cats: []
}

ProductSearchExtra.propTypes = {
  title:      PropTypes.string,
  count:      PropTypes.number,
  page:       PropTypes.number,
  query:      PropTypes.string,
  cats:       PropTypes.oneOfType( [
    PropTypes.array,
    PropTypes.string
  ] ),
  extra:      PropTypes.string,
  extraValue: PropTypes.string,
  filter:     PropTypes.object,
  onload:     PropTypes.func,
  repeat:     PropTypes.any.isRequired
}

export default ProductSearchExtra



// WEBPACK FOOTER //
// ./src/components/Product/ProductSearchExtra.js